/* Copyright (c) 2022 MOCA Systems, Inc.	All rights reserved. */

import { ExportFormatType } from './ExportFormatType';
import * as strings from '@touchplan/strings';

export interface IOrderedExportFormatType {
	sortingOrdinal: number;
	type: ExportFormatType;
}

export const exportFormatTypeMap = new Map<string, IOrderedExportFormatType>([
	[strings.REPORT_EXPORT_TICKETS_FORMAT_TOUCHPLAN, { sortingOrdinal: 10, type: ExportFormatType.Touchplan }],
	[strings.REPORT_EXPORT_TICKETS_FORMAT_P6, { sortingOrdinal: 20, type: ExportFormatType.P6Excel }],
	[strings.REPORT_EXPORT_TICKETS_FORMAT_CSV, { sortingOrdinal: 30, type: ExportFormatType.CSV }],
	[strings.REPORT_EXPORT_TICKETS_FORMAT_OPC, { sortingOrdinal: 40, type: ExportFormatType.OPCExcel }],
	[strings.REPORT_EXPORT_TICKETS_FORMAT_MSP, { sortingOrdinal: 50, type: ExportFormatType.MSPExcel }],
]);
